module.exports = __webpack_public_path__ + "static/img/card_icon_write@2x.864033f4.png";